export default __webpack_public_path__ + "static/media/nobg.b4a99431.jpg";